export type EventHandler = (e: unknown) => void;

export class EventEmitter
{
    private events = new Map<string, Set<EventHandler>>();

    public get eventsList(): string[]
    {
        return Array.from(this.events.keys());
    }

    public on(event: string, handler: EventHandler): void
    {
        if (!this.events.has(event))
        {
            this.events.set(event, new Set());
        }

        this.events.get(event)?.add(handler);
    }

    public off(event: string, handler: EventHandler): void
    {
        this.events.get(event)?.delete(handler);
    }

    public emit(event: string, e: unknown): void
    {
        this.events.get(event)?.forEach(handler => void handler(e));
    }
}
